module.exports = __webpack_public_path__ + "static/img/file_music.33d73714.png";